



















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import AppConsts from "@/lib/appconst";
import EmployeeProductivityReportOutput from "@/store/entities/employee_productivity_report_output";
import moment from "moment";
import _ from "lodash";

class PageEmployeeProductivityReportRequest {
  warehouseCode: string;
  fromDate?: string;
  toDate?: string;
}
@Component
export default class EmployeeProductivityReport extends AbpBase {
  //filters
  pagerequest: PageEmployeeProductivityReportRequest =
    new PageEmployeeProductivityReportRequest();
  warehouses = [];
  creationTime: Date[] = [];
  reportResult: EmployeeProductivityReportOutput =
    new EmployeeProductivityReportOutput();
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  viewDateWarning() {
    var argus = [AppConsts.reportRangeDays.range180.toString()];
    return Util.L("RangeDaysTooltip", "", ...argus);
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.$set(
          this.pagerequest,
          "warehouseCode",
          re.length === 0 ? "" : re[0].id
        );
        this.warehouses = re;
      });
  }
  get totalItems() {
    var argus = ["0"];
    if (
      !Util.isNull(this.reportResult) &&
      !Util.isNull(this.reportResult.items)
    ) {
      argus = [this.reportResult.items.length.toString()];
    }
    return Util.L("TotalItems", "", ...argus);
  }
  get list() {
    return this.reportResult.items;
  }
  get loading() {
    return this.$store.state.report.loading;
  }
  async exportToExcel() {
    this.buildPageRequest();
    await this.$store.dispatch({
      type: "report/exportEmployeeProductivity",
      data: this.pagerequest,
    });
  }
  buildPageRequest() {
    var warehouseCode = this.pagerequest.warehouseCode;
    if (this.isTenant()) {
      this.pagerequest.warehouseCode =
        this.$store.state.session.tenant.tenancyName;
    }
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .utc()
        .format();
    } else {
      this.pagerequest.fromDate = null;
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .utc()
        .format();
    } else {
      this.pagerequest.toDate = null;
    }
  }
  async getpage() {
    this.buildPageRequest();
    //filters
    await this.$store
      .dispatch({
        type: "report/getEmployeeProductivityReport",
        data: this.pagerequest,
      })
      .then((result) => {
        this.reportResult = result;
      })
      .catch((e) => {
        this.$store.state.report.loading = false;
      });
  }
  columns = [
    {
      title: Util.L("EmployeeCode"),
      width: 150,
      key: "userName",
    },
    {
      title: Util.L("FullName"),
      width: 200,
      key: "name",
    },
    {
      title: Util.L("ReceivedQty"),
      width: 150,
      key: "receivedQty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.receivedQty));
      },
    },
    {
      title: Util.L("PutawayQty"),
      width: 150,
      key: "putAwayQty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.putAwayQty));
      },
    },
    {
      title: Util.L("PickedQty"),
      width: 150,
      key: "pickedQty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.pickedQty));
      },
    },
    {
      title: Util.L("PackedQty"),
      width: 150,
      key: "packedQty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.packedQty));
      },
    },
    {
      title: Util.L("MovedQty"),
      width: 150,
      key: "movedQty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.movedQty));
      },
    },
    {
      title: Util.L("HandoverQty"),
      width: 150,
      key: "handOverQty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.handOverQty));
      },
    },
  ];
  async created() {
    await this.getWarehouses();
    var defaultDate = new Date();
    this.creationTime = [defaultDate, defaultDate];
  }
}
